import { createModel } from "@rematch/core";
import { randomHexColor } from "random-hex-color-generator";

import type { RootModel } from '.';
import { GeofenceTypes } from "../types/geofence.types";

export interface GeofenceStoreProps {
    geofences: GeofenceTypes.Model[],
    geoPhones: GeofenceTypes.GeofencePhoneNumber[],
    loading: {
        updateGeoPhone: boolean,
        createGeoPhone: boolean,
        updateGeofence: boolean,
        createGeofence: boolean,
        fetchGeofences: boolean,
        fetchGeoPhones: boolean,
        deleteGeofence: boolean,
        deleteGeoPhone: false,
    },
}

export const geofenceInitialState = {
    geofences: [] as GeofenceTypes.Model[],
    geoPhones: [] as GeofenceTypes.GeofencePhoneNumber[],
    loading: {
        updateGeoPhone: false,
        createGeoPhone: false,
        deleteGeoPhone: false,
        updateGeofence: false,
        createGeofence: false,
        fetchGeofences: false,
        fetchGeoPhones: false,
        deleteGeofence: false,
    },
};

export const geofences = createModel<RootModel>()({
    state: geofenceInitialState,
    reducers: {
        deleteGeofence: (store, id: string) => {
            store.geofences = store.geofences.filter((g) => g.id !== id);
        },
        deleteGeoPhone: (store, id: string) => {
            store.geoPhones = store.geoPhones.filter((g) => g.id !== id);
        },
        setGeofences: (store, geofences: GeofenceTypes.Model[]) => {
            store.geofences = geofences?.map((geo) => ({ ...geo, color: randomHexColor() }));
        },
        setGeoPhones: (store, geoPhones: GeofenceTypes.GeofencePhoneNumber[]) => {
            store.geoPhones = geoPhones;
        },
        toggleLoading: (
            store, prop: keyof GeofenceStoreProps['loading'], v: boolean) => {
            store.loading[prop] = v;
        },
        updateGeofence: (
            store, geofence: GeofenceTypes.Model
        ) => {
            const index = store.geofences.findIndex((g) => g.id === geofence.id);
            store.geofences[index] = {
                ...geofence,
                color: store.geofences[index].color,
            };
        },
        addGeofence: (
            store, geofence: GeofenceTypes.Model,
        ) => {
            store.geofences = store.geofences.concat({ ...geofence, color: randomHexColor() });
        },
        updateGeoPhone: (
            store, phone: GeofenceTypes.GeofencePhoneNumber,
        ) => {
            const index = store.geoPhones.findIndex((g) => g.id === phone.id);
            store.geoPhones[index] = phone;
        },
        addGeofencePhone: (
            store,
            phone: GeofenceTypes.GeofencePhoneNumber,
        ) => {
            store.geoPhones = store.geoPhones.concat(phone);
        },
    }
});